import React, { useState } from 'react';
import { Storage, Translate } from 'react-jhipster';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { BranchSettingsLocal } from 'app/entities/bank/bank-detail/branch-settings-local';
import { BranchSettingsInternational } from 'app/entities/bank/bank-detail/branch-settings-international';

interface BranchSettingsWrapperProps {
  account: any;
  branchEntity: any;
  isUserAuthorizedToEdit: boolean;
}

export function BranchSettingsWrapper({ account, branchEntity, isUserAuthorizedToEdit }: BranchSettingsWrapperProps) {
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <div className="branch-settings-section mb-4">
      <Box sx={{ backgroundColor: '#fafafa', borderRadius: 2, padding: 3 }}>
        <Tabs value={tabIndex} onChange={handleTabChange} aria-label="branch settings tabs" textColor="primary" indicatorColor="primary">
          <Tab
            label={<Translate contentKey="comexApp.branch.settings.tabs.international" />}
            sx={{ fontWeight: tabIndex === 0 ? 'bold' : 'normal' }}
          />
          <Tab
            label={<Translate contentKey="comexApp.branch.settings.tabs.local" />}
            sx={{ fontWeight: tabIndex === 1 ? 'bold' : 'normal' }}
          />
        </Tabs>

        <Box sx={{ marginTop: 2 }}>
          {tabIndex === 0 && (
            <BranchSettingsInternational account={account} branchEntity={branchEntity} isUserAuthorizedToEdit={isUserAuthorizedToEdit} />
          )}
          {tabIndex === 1 && (
            <BranchSettingsLocal account={account} branchEntity={branchEntity} isUserAuthorizedToEdit={isUserAuthorizedToEdit} />
          )}
        </Box>
      </Box>
    </div>
  );
}
